import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters.js";

export class Media extends DataObject {
    _type = "media";

    id;
    source_url;
    source_url_small;
    source_url_medium;
    source_url_large;
}

export class ProductMedia extends Media {
    title;
    embed_link;
    hash;
    position;
}

export class MediaMapperParameter extends Parameter {
    mediaMapper;
}

export class MediaFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {Object, null} data Data to construct the Media object with. Also creates a product object using MetaFactory if data is not null.
     * @returns {Media}
     */
    static construct(mediaMapperParameter, data = null) {
        if (data != null) {
            let media = DataObjectFactory.getInstance().constructWithMapper(
                Media,
                mediaMapperParameter.mediaMapper,
                data
            );

            return media;
        }

        return null;
    }
}

export class ProductMediaFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {Object, null} data Data to construct the Media object with. Also creates a product object using MetaFactory if data is not null.
     * @returns {ProductMedia}
     */
    static construct(mediaMapperParameter, data = null) {
        if (data != null) {
            let media = DataObjectFactory.getInstance().constructWithMapper(
                ProductMedia,
                mediaMapperParameter.mediaMapper,
                data
            );

            return media;
        }

        return null;
    }
}
